import { MenuItem } from 'vue-graphql-models';

export default [
  new MenuItem({
    id: 'newOrganization',
    title: 'Create New Organization',
    route: { name: 'createNewOrganization' },
    subtitle: 'Add new company',
    customIcon: true,
    icon: 'dhc-building',
  }),
  new MenuItem({
    id: 'newUser',
    title: 'Create New User',
    route: { name: 'createNewUser' },
    subtitle: 'Add New User',
    icon: 'person',
  }),
];
